import { parse } from "date-fns";

const parseQuarter = (dateParts: string[]) => {
  const quarter = dateParts[0];
  const year = dateParts[1];
  let month: string;

  switch (quarter.toLowerCase()) {
    case "2q":
      month = "04";
      break;
    case "2h":
    case "3q":
      month = "07";
      break;
    case "4q":
      month = "10";
      break;
    default:
      month = "01";
      break;
  }
  return parse(`${month}/${year}`, "MM/yyyy", new Date());
};

const parseShort = (dateStr: string) => {
  const dateSplit = dateStr.split(" ");
  const isQuarterDate = dateSplit.length === 2;

  if (isQuarterDate) {
    return parseQuarter(dateSplit);
  } else {
    return parse(dateStr, "MM/yyyy", new Date());
  }
};

const parseLong = (dateStr: string) => {
  const dateSplit = dateStr.includes("/") ? dateStr.split("/") : dateStr.split(" ");

  let month: string;
  let day: string;
  let year: string;

  if (dateSplit.length === 2) {
    month = dateSplit[0].replace(/,\s*$/, "");
    day = "1";
    year = dateSplit[1];
  } else {
    month = dateSplit[0];
    day = dateSplit[1].replace(/,\s*$/, "");
    year = dateSplit[2];
  }

  return parse(`${month}/${day}/${year}`, "MMMM/dd/yyyy", new Date());
};

const parseYear = (year: string) => parse(year, "yyyy", new Date());

export const parseString = (dateStr: string | null) => {
  if (!dateStr) return new Date("01/01/9999"); // Hack to put null at end

  try {
    switch (dateStr.length) {
      case 4:
        return parseYear(dateStr);
      case 6:
        return parse(dateStr, "M/yyyy", new Date());
      case 7:
        return parseShort(dateStr);
      case 8:
        return parse(dateStr, "M/d/yyyy", new Date());
      case 9:
        return parse(dateStr, "M/dd/yyyy", new Date());
      case 10:
        return parse(dateStr, "MM/dd/yyyy", new Date());
      default:
        return parseLong(dateStr);
    }
  } catch (err) {
    if (dateStr) console.log(`error parsing dateStr ${dateStr}`);
    return new Date("01/01/9999"); // Hack to put null at end
  }
};
